import Footer from "../../components/footer/Footer";
import SalesSupportForm from "../../components/support/salesForm";
import SupportHeader from "../../components/support/supportHeader";

const SalesSupport = () => {
  return (
    <>
      <SupportHeader
        heading={"Contact Sales"}
        subtitle={
          "We’re excited to partner with you in achieving your business objectives!"
        }
      />
      <SalesSupportForm />
      <Footer />
    </>
  );
};

export default SalesSupport;
